module.exports = {"pathContext":{"name":"ProviderImportErrorType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DUPLICATE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"INVALID"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-provider-import-error-type.json
// module id = 1290
// module chunks = 39254217752474